// prettier-ignore
export default "fs"